import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { useI18n } from "../context/I18nContext";
import { isPhotoImage } from "../utils/images";

const CATEGORY_CLASSES = {
  healthy: "tag-healthy",
  tasty: "tag-tasty",
  balanced: "tag-balanced",
};

export default function MealCard({ meal, onClick, style = {}, showDessertType = false }) {
  const { state, actions } = useApp();
  const { t } = useI18n();
  const [opening, setOpening] = useState(false);
  const isFav = state.favoriteIds.includes(meal.id);
  const categoryClass = CATEGORY_CLASSES[meal.category] || CATEGORY_CLASSES.balanced;
  const categoryLabel = meal.localized?.category || t(meal.category || "balanced");
  const mealTypeLabel = showDessertType
    ? meal.localized?.dessertType || meal.dessertType
    : meal.localized?.mealType || t(meal.mealType || "meal");

  const handleFav = async (event) => {
    event.stopPropagation();
    await actions.toggleFavorite(meal.id);
  };

  const handleOpen = async () => {
    if (opening) return;
    setOpening(true);
    try {
      onClick?.();
    } catch (error) {
      window.alert(error.message || t("requestFailed"));
    } finally {
      setOpening(false);
    }
  };

  return (
    <div className={`meal-card ${opening ? "opening" : ""}`} onClick={handleOpen} style={style}>
      <div className={`meal-card-emoji ${isPhotoImage(meal.image) ? "has-photo" : ""}`}>
        {isPhotoImage(meal.image) ? <img src={meal.image} alt={meal.title} /> : meal.image}
      </div>
      <div className="meal-card-body">
        <div className="meal-card-title">{meal.title}</div>
        <div className="meal-card-meta">
          <span className="tag tag-cuisine">{meal.localized?.cuisine || meal.cuisine}</span>
          <span className={`tag ${categoryClass}`}>{categoryLabel}</span>
          <span className="tag tag-meal">{mealTypeLabel}</span>
        </div>
      </div>
      <div className="meal-card-footer">
        <span>⏱ {meal.prepTime + meal.cookTime} {t("minutes")}</span>
        <span>{Number(meal.calories) > 0 ? `🔥 ${meal.calories} ${t("kcal")}` : t("nutritionUnverified")}</span>
        <span>★ {meal.averageRating || 0}</span>
        <button className="fav-btn" onClick={handleFav} title={isFav ? t("favoriteRemove") : t("favoriteAdd")}>
          {isFav ? "♥" : "♡"}
        </button>
      </div>
    </div>
  );
}
